import { LocationStrategy } from '@angular/common';
import {
  Directive,
  HostBinding,
  HostListener,
  Injectable,
  Input,
} from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

type Params = { [key: string]: any };

@Injectable()
export class QueryLinkHelper {
  constructor(private readonly route: ActivatedRoute) {}

  params(params: Params): NavigationExtras {
    return {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
      replaceUrl: true,
    };
  }
}

// DEPRECATED:  replaced by rivetLink
@Directive({
  providers: [QueryLinkHelper],
  selector: ':not(a):not(area)[queryLink]',
})
export class QueryLinkDirective {
  @Input()
  queryLink: { [key: string]: any };

  constructor(
    private readonly queryLinkHelper: QueryLinkHelper,
    private readonly router: Router,
  ) {}

  @HostListener('click')
  click() {
    this.router.navigate([], this.queryLinkHelper.params(this.queryLink));
  }
}

@Directive({
  providers: [QueryLinkHelper],
  selector: 'a[queryLink], area[queryLink]',
})
export class QueryLinkDirectiveWithHref {
  @HostBinding('attr.target') @Input() target!: string;

  @Input()
  queryLink: { [key: string]: any };

  constructor(
    private readonly locationStrategy: LocationStrategy,
    private readonly queryLinkHelper: QueryLinkHelper,
    private readonly router: Router,
  ) {}

  @HostListener('click', [
    '$event.button',
    '$event.ctrlKey',
    '$event.metaKey',
    '$event.shiftKey',
  ])
  onClick(
    button: number,
    ctrlKey: boolean,
    metaKey: boolean,
    shiftKey: boolean,
  ): boolean | undefined {
    if (
      button !== 0 ||
      ctrlKey ||
      metaKey ||
      shiftKey ||
      (typeof this.target === 'string' && this.target != '_self')
    ) {
      return;
    }

    this.router.navigate([], this.queryLinkHelper.params(this.queryLink));
    return false;
  }

  @HostBinding()
  get href() {
    const urlTree = this.router.createUrlTree(
      [],
      this.queryLinkHelper.params(this.queryLink),
    );
    return this.locationStrategy.prepareExternalUrl(
      this.router.serializeUrl(urlTree),
    );
  }
}
